import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AssetEvent, AssetVariable } from '@iot-platform/models/i4b';
import { DateFormatPipe, InfoDisplayPipe, ValueUnitFormatPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { CardLoaderComponent } from '../../card-loader/card-loader.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, DateFormatPipe, InfoDisplayPipe, ValueUnitFormatPipe, CardLoaderComponent],
  selector: 'iot-platform-ui-detail-asset-variable-card',
  templateUrl: './detail-asset-variable-card.component.html',
  styleUrls: ['./detail-asset-variable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DateFormatPipe, InfoDisplayPipe, ValueUnitFormatPipe]
})
export class DetailAssetVariableCardComponent {
  currentAssetVariable = input<AssetVariable | null | undefined>(undefined);
  event = input<AssetEvent>();

  computedContextVariable = computed(() => {
    const contextVar = this.event()?.context?.assetVariable;
    return contextVar ? ({ unit: contextVar.unit, lastValue: { value: contextVar.value } } as AssetVariable) : undefined;
  });
}
